<template>
  <!-- <v-layout row justify-center> -->

  <div flat v-if="blueprint.blueprintFile.content">
    <div v-bind:style="{ display: fullscreen || !$store.state.isMobile ? 'block': 'none'}">
      <v-toolbar dense dark flat color="#3a5973">
        <v-btn v-if="fullscreen" icon dark @click="fullscreen = !fullscreen">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{$t("blueprint")}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="!detailPage && !readonly  && $store.state.markers.length == 0">
          <!-- <label for="fileInput" class="flex-fill" slot="upload-label">
              <image-uploader
                :preview="false"
                className="fileInput"
                id="fileInput"
                quality="1"
                accept=".jpg"
                outputFormat="verbose"
                @input="changeBlueprintImage"
              ></image-uploader>
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      v-if="!$store.state.isOffline"
                      text
                    >
                      <v-icon>fa-trash-alt</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('changeBlueprintImage')}}</span>
                </v-tooltip>
              </div>
          </label>-->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn @click="deleteBlueprintFile" v-on="on" v-if="!$store.state.isOffline" text>
                <v-icon>fa-trash-alt</v-icon>
              </v-btn>
            </template>
            <span>{{$t('deleteBlueprintImage')}}</span>
          </v-tooltip>
        </v-toolbar-items>
        <v-toolbar-items>
          <v-btn v-if="!fullscreen" @click="fullscreen = !fullscreen" text>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon>settings_overscan</v-icon>
                </div>
              </template>
              <span>{{$t('fullscreen')}}</span>
            </v-tooltip>
          </v-btn>
        </v-toolbar-items>
        <can i="update" a="blueprints">
          <v-toolbar-items
            v-if="!$store.state.isMobile && !$store.state.isOffline && !fullscreen && !detailPage && ($store.state.markers.length > 0 || $store.state.markersReadonly.length > 0)"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn small icon v-on="on" color="white" text>
                  <downloadLogbook v-on:download="generateLogbook">
                    <template v-slot:activator="{ on }">
                      <v-btn small icon v-on="on" color="white" text>
                        <v-icon>import_contacts</v-icon>
                      </v-btn>
                    </template>
                  </downloadLogbook>
                </v-btn>
              </template>
              <span>{{$t('downloadLogbook')}}</span>
            </v-tooltip>
          </v-toolbar-items>
        </can>
        <v-toolbar-items v-if="!detailPage && !readonly  && $store.state.markers.length > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text @click="update">
                <v-icon v-if="!$store.state.hasChanges">save</v-icon>
                <v-badge v-else color="orange">
                  <template v-slot:badge>
                    <v-icon dark small>priority_high</v-icon>
                  </template>
                  <v-icon>save</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>{{$t('saveMarkerPosition')}}</span>
          </v-tooltip>
        </v-toolbar-items>
        <v-toolbar-items v-if="!detailPage && !readonly">
          <v-btn text @click="$store.state.drawable = !$store.state.drawable">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon :color="$store.state.drawable ? 'secondary' : 'white'" v-on="on">fa-edit</v-icon>
              </template>
              <span>{{$t('newMarker')}}</span>
            </v-tooltip>
          </v-btn>
        </v-toolbar-items>
        <v-toolbar-items v-if="!readonly && !markerDetailView">
          <v-btn text @click="moveMarker = !moveMarker">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-icon :color="moveMarker ? 'secondary' : 'white'">fa-arrows-alt</v-icon>
                </div>
              </template>
              <span>{{$t('moveMarker')}}</span>
            </v-tooltip>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-sheet
        ref="markup-wrapper"
        tile
        :max-height="fullscreen ? '100%' :700"
        class="overflow-hidden"
      >
        <v-stage
          v-bind:class="{'fit_blueprint': (!fullscreen)}"
          class="blueprint"
          ref="stageFullscreen2"
          @touchstart="disableSwipeTogoBack"
          :config="stageSize"
          @touchend="pinchEnd"
          @touchmove="pinch"
        >
          <v-layer ref="layer2" :config="layerSize">
            <v-image
              @click="unSelect"
              @touchend="handleTouchEnd"
              @mousedown="handleTouchMove"
              @mouseup="handleTouchEnd"
              @touchmove="handleTouchMove"
              :config="{
                      image: image,
                    }"
            />
            <v-group
              ref="group"
              v-for="(marker) in markers"
              :key="marker.id"
              :config="{
              visible: groupConfig.visible,
            }"
            >
              <v-rect
                @dragmove="adjustPoint"
                @dragend="updatePosition"
                :config="{
                id:marker.id,
                      x: marker.xRect,
                      y: marker.yRect,
                      width: 10,
                      height: 10,
                      stroke: 'rgba(76, 175, 80, 0)',
                      strokeWidth: 25,
                      fill: color(marker),
                      draggable: moveMarker,
                       dragBoundFunc: (pos)=>{
                         return dragBound(pos)
                       }                
                    }"
              />

              <v-line
                :config="{
                      points: [marker.xStartLine, marker.yStartLine, marker.xEndLine, marker.yEndLine],
                      stroke: color(marker),
                    }"
              />

              <v-circle
                v-bind:config="{
                      x: marker.xCircle,
                      y: marker.yCircle,
                      radius: 20,
                      width: 35,
                      height: 35,
                      fill: color(marker),
                      stroke: color(marker),
                      strokeWidth: 8,
                    }"
              />
              <v-circle
                v-bind:config="{
                      x: marker.xCircle,
                      y: marker.yCircle,
                      radius: 20,
                      width: 35,
                      height: 35,
                      fill: color(marker),
                      stroke: color(marker),
                      strokeWidth: 8,
                    }"
              />
              <template v-if="marker.label && marker.label !== ''">
                <v-rect
                  @dragmove="adjustText"
                  @dragend="updatePosition"
                  @dbltap="showDetails(marker)"
                  @dblclick="showDetails(marker)"
                  :config="{
                id:marker.id,
                      x: marker.xLabel -60,
                      y: marker.yLabel +30,
                      width: 160,
                      height: 25,
                      stroke: 'rgba(76, 175, 80, 0)',
                      strokeWidth: 10,
                      fill: color(marker),
                      draggable: moveMarker,
                       dragBoundFunc: (pos)=>{
                         return dragBound(pos)
                       }                
                    }"
                />
                <v-text
                  @dragmove="adjustText"
                  @dragend="updatePosition"
                  @dbltap="showDetails(marker)"
                  @dblclick="showDetails(marker)"
                  :config="{
                id:marker.id,
                      x: marker.xLabel -60,
                      y: marker.yLabel +35,
                      text: marker.label,
                      draggable: moveMarker,
                      fontSize: 16,
                      fontStyle: 'bold',
                      fill: '#FFFF',
                      wrap: 'char',
                      width: 160,
                      height: 25,
                      align: 'center',
                       dragBoundFunc: (pos)=>{
                         return dragBound(pos)
                       }
                    }"
                />
              </template>
              <v-text
                @dragmove="adjustText"
                @dragend="updatePosition"
                @dbltap="showDetails(marker)"
                @dblclick="showDetails(marker)"
                :config="{
                id:marker.id,
                      x: marker.xLabel,
                      y: marker.yLabel,
                      text: marker.text,
                      draggable: moveMarker,
                      fontSize: 16,
                      fontStyle: 'bold',
                      fill: '#FFFF',
                      wrap: 'char',
                      width: 35,
                      height: 35,
                      align: 'center',
                       dragBoundFunc: (pos)=>{
                         return dragBound(pos)
                       }
                    }"
              />
            </v-group>
          </v-layer>
          <v-layer>
            <v-image
              ref="icon"
              @click="resetView()"
              @touchstart="resetView()"
              v-if="isZoomed"
              @mouseover="pointer"
              @mouseleave="defaultCursor"
              :config="{
                      image: icon,
                      width: 50,
                      height: 50,
                    }"
            />
          </v-layer>
        </v-stage>
      </v-sheet>
    </div>
    <div class="d-flex" v-if="$store.state.isMobile">
      <v-btn
        class="mx-auto"
        small
        rounded
        @click="fullscreen = !fullscreen"
        color="secondary"
      >{{$t('showBlueprintImage')}}</v-btn>
    </div>
    <loadingDialog :text="loadingText" :dialog="loading"></loadingDialog>
  </div>
  <uploadBlueprint v-else :blueprintId="blueprint.id" :readonly="readonly" blueprintPage></uploadBlueprint>
  <!-- </v-layout> -->
</template>

<script>
import { mapGetters } from "vuex";
import { Promise, all } from "q";
import uuid from "uuid";
import uploadBlueprint from "@/components/pages/Blueprints/UploadBlueprint";
import downloadLogbook from "@/components/DownloadLogbook";

let lastDist = 0;
let point;
var startPos;
const body = document.body,
  html = document.documentElement;

let height = Math.max(html.clientHeight);

let width = Math.max(html.clientWidth);

export default {
  components: {
    uploadBlueprint,
    downloadLogbook,
  },
  props: {
    detailPage: Boolean,
    readonly: Boolean,
    blueprint: Object,
  },
  data() {
    return {
      markerDetailView: false,
      moveImage: false,
      moveMarker: false,

      clickedInImage: false,
      dialog: false,
      layerSize: {
        draggable: true,
        x: null,
        duration: 0.5,
      },
      groupConfig: {
        visible: true,
      },
      image: null,
      icon: null,
      i: require("@/assets/baseline-fullscreen-24px.svg"),
      isZoomed: false,
      hover: false,
      overview: false,
      scale: null,
      fullscreen: false,
      stageSize: {
        width: 0,
        height: 0,
      },
      loading: false,
      loadingText: null,
      addedEventlistener: false,
      activeMarker: null,
    };
  },
  methods: {
    resizeStage() {
      height = Math.max(html.clientHeight);
      width = Math.max(html.clientWidth);
      this.stageSize.width = width;
      this.stageSize.height = height;
    },
    disableSwipeTogoBack() {
      if (this.addedEventlistener == false) {
        const element = document.getElementsByClassName("blueprint")[0];
        if (element) {
          this.addedEventlistener = true;
          element.addEventListener("touchstart", (e) => {
            // is not near edge of view, exit
            if (e.pageX > 10 && e.pageX < window.innerWidth - 10) return;

            // prevent swipe to navigate back gesture
            e.preventDefault();
          });
        }
      }
    },
    async deleteBlueprintFile() {
      try {
        await this.$http.deleteBlueprintFile(this.blueprint.id);
        this.$router.go();
      } catch (error) {
        console.log(error);
        this.$noty.error(error);
      }
    },
    dragBound(pos) {
      //prevent markers to be outside blueprint image
      let X = pos.x;
      let Y = pos.y;
      let minX = this.layer2.getX() + 10;
      let maxX =
        this.layer2.getX() + this.layer2.attrs.scaleX * (this.image.width - 30);
      let minY = this.layer2.getY() + 10;
      let maxY =
        this.layer2.getY() +
        this.layer2.attrs.scaleY * (this.image.height - 30);
      if (X < minX) {
        X = minX;
      }
      if (X > maxX) {
        X = maxX;
      }
      if (Y < minY) {
        Y = minY;
      }
      if (Y > maxY) {
        Y = maxY;
      }
      return {
        x: X,
        y: Y,
      };
    },
    color(marker) {
      //change color based on status
      if (marker.draggable) {
        return this.$store.state.colors.highlight;
      } else if (marker.status == 0) {
        return this.$store.state.colors.error;
      } else if (marker.status == 1) {
        return this.$store.state.colors.orange;
      } else if (marker.status == 2) {
        return this.$store.state.colors.green;
      } else return this.$store.state.colors.primary;
    },
    postMarker(o) {
      console.log("Posting Marker for Blueprint " + this.blueprint.id);

      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }

      if (this.$store.state.isOffline) {
        this.$noty.warning(this.$t("cached"));
        o.number =
          this.$store.getters.markers.length == 0
            ? 1
            : Math.max.apply(
                Math,
                this.$store.getters.markers.map((x) => x.number)
              ) + 1;
        o.new = true;

        // this.$store.commit("offAddAndSetUIelements", o);
        this.$store.commit("AddAndSetUIelements", o);

        let offForm = {
          marker: o,
        };
        this.$store.commit("addOrUpdateOffForm", offForm);
        // this.addMarkerToDb(o);
      } else {
        this.$http
          .addMarker(o)
          .then((res) => {
            this.$store.commit("AddAndSetUIelements", res.data);
            this.$store.commit("AddAndSetUIelementsReadonly", res.data);
            this.$noty.success('<i class="fas fa-check"></i>');
            //this.$store.state.drawable = true;
          })
          .catch((err) => {
            this.$noty.error(this.$t("error"));
            console.log(err);
          });
      }
    },
    fitBlueprint() {
      //fits blueprint inside stagesize
      //not necessary
      let stage = this.$refs.stageFullscreen2.getStage();
      var container = stage.container();
      //scalefactor = desiredSize / size, for both width and height
      //desiredSize
      var containerWidth = container.offsetWidth;
      this.scale = containerWidth / this.stageSize.width;

      stage.width(this.stageSize.width * this.scale);
      stage.height(this.stageSize.height * this.scale);

      //scaling
      stage.scale({ x: this.scale, y: this.scale });
      stage.draw();
    },
    hideMarkers() {
      //this.groupConfig.visible = false;
    },
    handleTouchMove(event) {
      if (this.$store.state.drawable) {
        //hide all other markers
        this.hideMarkers();

        this.layerSize.draggable = false;
        if (startPos === undefined) {
          startPos = this.$refs.stageFullscreen2
            .getStage()
            .getPointerPosition();

          // let layer = this.$refs.stageFullscreen2.getStage().children[0];
          let stage = this.$refs.stageFullscreen2.getStage();
          //If images has been moved..
          if (
            this.layer2.position().x != startPos.x &&
            this.layer2.position().y != startPos.y
          ) {
            console.log("start");
            if (this.layer2.scaleX() === 1) {
              //in order to draw the markers in the correct position if the image has been moved
              startPos.x -= this.layer2.position().x;
              startPos.y -= this.layer2.position().y;
              startPos.x = startPos.x / this.scale;
              startPos.y = startPos.y / this.scale;
            } else {
              //todo when image is zoomed, put markers on correct spot
              //this.layer2.scaleX();
              startPos.x -= this.layer2.position().x;
              startPos.y -= this.layer2.position().y;
              startPos.x = startPos.x / this.layer2.scaleX() / this.scale;
              startPos.y = startPos.y / this.layer2.scaleX() / this.scale;
            }
          }

          console.log("Touch start: " + startPos.x + ", " + startPos.y);
        }
      } else {
        this.layerSize.draggable = true;
        this.isZoomed = true;
      }
    },
    handleTouchEnd(event) {
      this.unSelect();
      if (this.$store.state.drawable) {
        this.$store.state.drawable = false;
        this.layerSize.draggable = false;
        let pos = this.$refs.stageFullscreen2.getStage().getPointerPosition();
        let layer = this.$refs.stageFullscreen2.getStage().children[0];
        let stage = this.$refs.stageFullscreen2.getStage();

         //If images has been moved..
        if (
          this.layer2.position().x != pos.x &&
          this.layer2.position().y != pos.y
        ) {
          if (this.layer2.scaleX() === 1) {
            //after many trial and error, here multiply x and y with the scale for some reason
            //in order to draw the markers in the correct position if the image has been moved
            pos.x -= this.layer2.position().x;
            pos.y -= this.layer2.position().y;
            pos.x = pos.x / this.scale;
            pos.y = pos.y / this.scale;
          } else {
            //this.layer2.scale({x: this.scale, y: this.scale});
            //todo when image is zoomed, put markers on correct spot
            pos.x -= this.layer2.position().x;
            pos.y -= this.layer2.position().y;
            pos.x = pos.x / this.layer2.scaleX() / this.scale;
            pos.y = pos.y / this.layer2.scaleX() / this.scale;
          }
        }

        let newMarker = {
          id: uuid.v4(),
          coordX: startPos.x,
          coordY: startPos.y,
          coordX2: pos.x,
          coordY2: pos.y,
          BluePrintId: this.blueprint.id,
          attachments: [],
          markerXSolutions: [],
        };
        this.postMarker(newMarker);
        startPos = undefined;

        if (!this.readonly) {
          this.$store.state.hasChanges = true;
        }

        console.log("Touched");
      } else {
        this.layerSize.draggable = true;
        this.isZoomed = true;
      }
      this.groupConfig.visible = true;
    },
    getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    },
    //zooming
    pinchZoomWheelEvent(stage) {
      if (this.$refs.stageFullscreen2) {
        stage.getContent().addEventListener("wheel", (e) => {
          if (e.ctrlKey) {
            let layer = stage.children[0];
            e.preventDefault();
            const oldScale = this.layer2.scaleX();
            oldScale == 1 ? (this.isZoomed = false) : (this.isZoomed = true);
            const pointer = stage.getPointerPosition();
            const startPos = {
              x: pointer.x / oldScale - this.layer2.x() / oldScale,
              y: pointer.y / oldScale - this.layer2.y() / oldScale,
            };

            const deltaYBounded = !(e.deltaY % 1)
              ? Math.abs(Math.min(-10, Math.max(10, e.deltaY)))
              : Math.abs(e.deltaY);
            const scaleBy = 1.01 + deltaYBounded / 70;
            const newScale =
              e.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
            this.layer2.scale({ x: newScale, y: newScale });

            const newPosition = {
              x: (pointer.x / newScale - startPos.x) * newScale,
              y: (pointer.y / newScale - startPos.y) * newScale,
            };
            this.layer2.position(newPosition);
            this.layer2.batchDraw();
          }
        });
      }
    },
    async generateLogbook(blueprintSeparated, withDocuments) {
      this.loading = true;
      

      //unselect markers
      this.$nextTick(async () => {
        let form = new FormData();
        form.append("blueprintId", this.blueprint.id);
        form.append("blueprintSeparated", blueprintSeparated);
        form.append("withDocuments", withDocuments);
        form.append("lc", localStorage.getItem("language"));
        this.$http
          .getLog(form)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let date = new Date();
            link.setAttribute(
              "download",
              `Logbook_${date.toLocaleDateString()}.${
                blueprintSeparated || withDocuments ? "zip" : "docx"
              }`
            );
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch((err) => {
            this.$noty.error(this.$t("error"));
            console.log(err);
            this.loading = false;
          });
      });
    },
    adjustPoint(e) {
      //adjust rect
      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }

      this.activeMarker = this.markers.find(
        (x) => x.id == e.currentTarget.attrs.id
      );

      let rec = e.currentTarget;
      this.activeMarker.coordX = rec.attrs.x;
      this.activeMarker.coordY = rec.attrs.y;
      this.activeMarker.xStartLine = rec.attrs.x;
      this.activeMarker.yStartLine = rec.attrs.y;
      this.activeMarker.coordX = rec.attrs.x;
      this.activeMarker.coordY = rec.attrs.y;
      this.activeMarker.xRect = rec.attrs.x;
      this.activeMarker.yRect = rec.attrs.y;
    },
    adjustText(e) {
      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }
      this.activeMarker = this.markers.find(
        (x) => x.id == e.currentTarget.attrs.id
      );
      let text = e.currentTarget;
      this.activeMarker.coordX2 = text.attrs.x + 17.5;
      this.activeMarker.coordY2 = text.attrs.y + 8.5;
      this.activeMarker.xCircle = text.attrs.x + 17.5;
      this.activeMarker.yCircle = text.attrs.y + 8.5;
      this.activeMarker.xEndLine = text.attrs.x + 17.5;
      this.activeMarker.yEndLine = text.attrs.y + 8.5;
      this.activeMarker.xLabel = text.attrs.x;
      this.activeMarker.yLabel = text.attrs.y;
    },
    grab() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "grab";
    },
    moveCursor() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "move";
    },
    pointer() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "pointer";
    },
    defaultCursor() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "default";
    },
    updatePosition(e) {
      this.$emit("update", this.activeMarker);
    },
    highlight(e) {
      let markerId = e.currentTarget.VueComponent.$vnode.data.key;
      let marker = this.$store.state.markers.find((x) => x.id == markerId);
      marker.highlight = true;
      this.$store.commit("highlight", marker);
      if (marker.draggable) this.grab();
      else this.pointer();

      let width = this.$refs.stageFullscreen2.$el.clientWidth;
      this.layerSize.x = -marker.coordX + width / 2;
    },
    unHighlight(e) {
      let markerId = e.currentTarget.VueComponent.$vnode.data.key;
      let marker = this.$store.state.markers.find((x) => x.id == markerId);
      if (marker.draggable) marker.highlight = true;
      else marker.highlight = false;
      this.$store.commit("unHighlight", marker);
      this.defaultCursor();
    },
    unSelect(e) {
      if (!this.$store.state.drawable) {
        this.$store.commit("select", null);
        this.$store.commit("selectReadonly", null);
        //document.getElementById(`marker-${i}`).scrollIntoView();
      }
    },
    select(marker, i) {
      this.clickedInImage = true;
      let stage = this.$refs.stageFullscreen2.getStage();
      //check if the user is drawing
      if (!this.$store.state.drawable) {
        this.$refs.stageFullscreen2.getStage().children[0].draw();

        marker.draggable = true;
        // this.layerSize.draggable = false;
        this.$store.commit("select", marker);
      }
    },
    showDetails(marker) {
      this.$emit("showMarkerDetails", marker);
    },
    update() {
      this.loading = true;
      if (this.$store.state.isOffline) {
        this.$store.getters.markers.forEach((element) => {
          let offForm = {
            marker: element,
          };
          this.$store.commit("addOrUpdateOffForm", offForm);
          this.$store.commit("AddAndSetUIelements", element);
        });
        this.$noty.warning(this.$t("cached"));
        this.$store.state.hasChanges = false;
        this.loading = false;
      } else {
        this.$store.state.markersReadonly = [];
        let requests = [];
        this.$store.getters.markers.forEach((element) => {
          requests.push(this.$http.updateMarker(element));
        });

        Promise.all(requests)
          .then((res) => {
            this.$noty.success('<i class="fas fa-check"></i>');
            this.$store.state.hasChanges = false;
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.$noty.error(this.$t("error"));
            this.loading = false;
          });
      }
    },
    resetView() {
      this.isZoomed = false;
      return new Promise((resolve) => {
        this.layer2.to({
          x: 0,
          y: 0,
          scaleX: 1,
          scaleY: 1,
          duration: 0.2,
          onFinish: resolve,
        });
      });

      // layer.scale({ x: 1.0, y: 1.0 });
      // layer.position({ x: 0, y: 0 });
    },
    focusMarker(marker) {
      if (!this.fullscreen && marker) {
        //focus on the marker point
        //width of stage

        let wrapper = this.$refs["markup-wrapper"].$el;
        if (!this.moveMarker) {
          if (this.$refs.stageFullscreen2) {
            let width = this.$refs.stageFullscreen2.$el.clientWidth;
            //height of stage
            let height = this.$refs.stageFullscreen2.$el.clientHeight;
            let layer = this.$refs.stageFullscreen2.getStage().children[0];
            //animate layer to focus on marker

            this.layer2.to({
              x: -marker.coordX + wrapper.clientWidth / 2,
              // + width / 2,
              y: -marker.coordY + wrapper.clientHeight / 2,
              // + height / 2
              scaleX: 1,
              scaleY: 1,
              duration: 0.2,
            });

            this.isZoomed = true;
          }
        }
      }
      this.clickedInImage = false;
    },
    pinch(e) {
      let stage = this.$refs.stageFullscreen2.getStage();
      let t1 = e.evt.touches[0];
      let t2 = e.evt.touches[1];
      let layer = stage.children[0];

      if (t1 && t2) {
        e.evt.preventDefault();
        e.evt.stopPropagation();
        let oldScale = this.layer2.scaleX();
        if (t1 && t2) {
          let dist = this.getDistance(
            {
              x: t1.clientX,
              y: t1.clientY,
            },
            {
              x: t2.clientX,
              y: t2.clientY,
            }
          );

          if (!lastDist) lastDist = dist;

          let delta = dist - lastDist;

          let scale = (this.layer2.scaleX() * dist) / lastDist;

          // this.layer2.scaleX(scale);
          // this.layer2.scaleY(scale);

          const px = (t1.clientX + t2.clientX) / 2;
          const py = (t1.clientY + t2.clientY) / 2;
          const pointer = point || {
            x: px,
            y: py,
          };
          if (!point) point = pointer;

          const startPos = {
            x: pointer.x / oldScale - this.layer2.x() / oldScale,
            y: pointer.y / oldScale - this.layer2.y() / oldScale,
          };

          const scaleBy = 1.01 + Math.abs(delta) / 100;
          const newScale = delta < 0 ? oldScale / scaleBy : oldScale * scaleBy;
          this.layer2.scale({ x: newScale, y: newScale });

          const newPosition = {
            x: (pointer.x / newScale - startPos.x) * newScale,
            y: (pointer.y / newScale - startPos.y) * newScale,
          };

          this.layer2.position(newPosition);

          this.layer2.draw();
          lastDist = dist;
        }
      }
    },
    pinchEnd(e) {
      lastDist = 0;
      point = undefined;
    },
    getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    },
    loadImage() {
      this.scale = 1;
      const image = new window.Image();
      this.$forceUpdate();
      this.$nextTick(() => {
        image.src = this.blueprint.blueprintFile.content; //"https://konvajs.org/assets/yoda.jpg";
      });

      image.onload = () => {
        // // set image only when it is loaded

        setTimeout(() => {
          this.image = image;
          //make stage same size as image
          var body = document.body,
            html = document.documentElement;

          var height = Math.max(html.clientHeight);

          let width = Math.max(html.clientWidth);
          //this.stageSize.width = image.width;
          this.stageSize.width = width;
          this.stageSize.height = height;
          // this.stageSize.height = height;
          // this.image.height > 700 ? this.image.height : 700;
        }, 0);

        this.pinchZoomWheelEvent(this.$refs.stageFullscreen2.getStage());
      };

      const i = new window.Image();
      i.src = this.i;
      this.icon = i;
    },
  },
  computed: {
    // stageSize() {
    //   var body = document.body,
    //     html = document.documentElement;

    //   var height = Math.max(html.clientHeight);

    //   let width = Math.max(html.clientWidth);
    //   return {
    //     width: width,
    //     height: height
    //   };
    // },
    // layer1(){
    //   return this.$refs.stageFullscreen2.getStage().children[0];
    // },
    stage() {
      return this.$refs.stageFullscreen2.getStage();
    },
    layer2() {
      return this.$refs.stageFullscreen2.getStage().children[0];
    },
    defaultStageSize() {
      return {
        width: width,
        height: height,
      };
    },
    markers() {
      if (this.readonly) {
        if (
          this.$store.getters.markersReadonly.filter(
            (x) => x.id == this.$route.params.id
          ).length != 0
        ) {
          //show only one marker on map
          this.overview = false;
          return this.$store.getters.markersReadonly.filter(
            (x) => x.id == this.$route.params.id
          );
        } else {
          this.overview = true;
          return this.$store.state.markersReadonly;
        }
      } else {
        if (
          this.$store.getters.markers.filter(
            (x) => x.id == this.$route.params.id
          ).length != 0
        ) {
          //show only one marker on map
          this.overview = false;
          return this.$store.getters.markers.filter(
            (x) => x.id == this.$route.params.id
          );
        } else {
          this.overview = true;
          return this.$store.state.markers;
        }
      }
    },
    drawable() {
      return this.$store.state.drawable;
    },
    openBlueprint() {
      return this.$store.state.openBlueprint;
    },
    // activeMarker() {
    //   return this.$store.state.markers.find(x => x.draggable);
    // }
  },
  watch: {
    fullscreen(n, o) {
      this.$emit("fullscreen");
      this.resizeStage();
    },
    markers(n, o) {
      if (n.some((e) => e.draggable)) {
        // this.layerSize.draggable = false;
        this.focusMarker(n.find((x) => x.draggable));
      }
    },
    activeMarker(n, o) {
      this.focusMarker(n);
    },
    moveMarker(n, o) {
      if (n) {
        this.moveCursor();
        this.$store.state.drawable = false;
      } else {
        this.defaultCursor();
      }
    },
    drawable(n, o) {
      if (n) {
        this.moveMarker = false;
        this.pointer();
      } else {
        this.defaultCursor();
      }
    },
    openBlueprint(n, o) {
      if (n) {
        this.fullscreen = true;
      }
    },
  },
  created() {
    this.loadImage();
    this.markerDetailView = this.$route.name === "MarkerDetails" || this.$route.name === "EditMarkerDetails";
    if (this.$route.name === "MarkerDetails") {
      this.markers.forEach((marker) => {
        if (marker.draggable) {
          marker.draggable = false;
        }
      });
    }
    //}
  },
};
</script>
<style scoped>
.fit_blueprint {
  overflow: hidden;
  min-height: 700px;
}
#fileInput {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Markers/MarkUpFullScreen.vue